import { createInputs } from '../../utils';

export default createInputs([{ name: 'title', type: 'string', required: true }]);
